// removed by extract-text-webpack-plugin
module.exports = {"side-bar":"styles-module__side-bar___1wD3y","bottom-button":"styles-module__bottom-button___22RrW","button":"styles-module__button___2NWJA","icon":"styles-module__icon___vl-qI"};


//////////////////
// WEBPACK FOOTER
// ./src/core/ui/SideBar/styles.module.css
// module id = 382
// module chunks = 0